module.exports = __webpack_public_path__ + "static/media/  (25).dc4ee9ee.jpg";